// launchDarklyHooks.web.ts

import { useEffect } from "react"
import { useFlags } from "launchdarkly-react-client-sdk"
import { useStore } from "@nanostores/react"
import {
  $isLaunchDarklyInitialized,
  registerLaunchDarklyFlagUse,
} from "@/stores/launchDarkly"

export const useLaunchDarklyInit = () => {
  useEffect(() => {
    console.log("useLaunchDarklyInit is a no-op on Web")
  }, [])

  return { ldClient: null }
}

// useBoolVariation function for web
export const useBoolVariation = (
  flagKey: string,
  defaultValue: boolean
): boolean => {
  const flags = useFlags()

  if (flags && flagKey in flags) {
    return registerLaunchDarklyFlagUse(flagKey, flags[flagKey])
  }

  return registerLaunchDarklyFlagUse(flagKey, defaultValue)
}

export const useStringVariation = (
  flagKey: string,
  defaultValue: string
): string => {
  const flags = useFlags()

  if (flags && flagKey in flags) {
    return registerLaunchDarklyFlagUse(flagKey, flags[flagKey])
  }

  return registerLaunchDarklyFlagUse(flagKey, defaultValue)
}

export const useIsLDReady = () => {
  return useStore($isLaunchDarklyInitialized)
}
